import { ErrorLoggingConfig } from '../interface/logger.interface';

export class LoggerConfig {
  static readonly defaultErrorLoggingConfig: ErrorLoggingConfig = {
    // Allow maximum 10 errors within the time window
    maxErrorsPerWindow: 5,

    // Time window of 10 seconds for rate limiting
    timeWindowMs: 10000,

    // Prevent logging the same error more than once every 10 seconds
    deduplicationWindowMs: 10000,

    // After 3 consecutive similar errors, treat as error loop
    consecutiveErrorThreshold: 3,
  };
}
